"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modes = exports.menuPositions = exports.positions = exports.AUTOCOMPLETE_ICON_HINT = exports.AUTOCOMPLETE_ICON_SHOW_MENU = exports.AUTOCOMPLETE_ICON_HIDE_MENU = exports.AUTOCOMPLETE_ICON_CLOSE = exports.MOVE_DOWN = exports.MOVE_UP = exports.ARROW_DOWN_KEYCODE = exports.ARROW_UP_KEYCODE = exports.ESCAPE_KEYCODE = exports.ENTER_KEYCODE = void 0;
var ENTER_KEYCODE = 13;
exports.ENTER_KEYCODE = ENTER_KEYCODE;
var ESCAPE_KEYCODE = 27;
exports.ESCAPE_KEYCODE = ESCAPE_KEYCODE;
var ARROW_UP_KEYCODE = 38;
exports.ARROW_UP_KEYCODE = ARROW_UP_KEYCODE;
var ARROW_DOWN_KEYCODE = 40;
exports.ARROW_DOWN_KEYCODE = ARROW_DOWN_KEYCODE;
var MOVE_UP = 1;
exports.MOVE_UP = MOVE_UP;
var MOVE_DOWN = -1;
exports.MOVE_DOWN = MOVE_DOWN;
var AUTOCOMPLETE_ICON_CLOSE = 'sbi-close';
exports.AUTOCOMPLETE_ICON_CLOSE = AUTOCOMPLETE_ICON_CLOSE;
var AUTOCOMPLETE_ICON_HIDE_MENU = 'sbi-chevron-up';
exports.AUTOCOMPLETE_ICON_HIDE_MENU = AUTOCOMPLETE_ICON_HIDE_MENU;
var AUTOCOMPLETE_ICON_SHOW_MENU = 'sbi-chevron-down';
exports.AUTOCOMPLETE_ICON_SHOW_MENU = AUTOCOMPLETE_ICON_SHOW_MENU;
var AUTOCOMPLETE_ICON_HINT = 'sbi-big-hint';
exports.AUTOCOMPLETE_ICON_HINT = AUTOCOMPLETE_ICON_HINT;
var positions = {
  TOP: 'top',
  BOTTOM: 'bottom'
};
exports.positions = positions;
var menuPositions = {
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right',
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right'
};
exports.menuPositions = menuPositions;
var modes = {
  MODE_CHECKBOX: 'checkbox',
  MODE_RADIO: 'radio'
};
exports.modes = modes;
//# sourceMappingURL=constants.js.map